export const CHANGE_LOGIN_SHOW = 'CHANGE_LOGIN_SHOW'

export const CHOOSE_MENU = 'CHOOSE_MENU'

export const BIND_MENU = 'BIND_MENU'

export const SET_BASEINFO = 'SET_BASEINFO'

export const ADDTO_BASEINFO = 'ADDTO_BASEINFO'

export const CLEAR_BASEINFO = 'CLEAR_BASEINFO'

export const CHANGE_PROMPT_SHOW = 'CHANGE_PROMPT_SHOW'

export const SET_PROMPT_INFO = 'SET_PROMPT_INFO'

export const SET_PROMPT_TYPE_PARAM = 'SET_PROMPT_TYPE_PARAM'

export const SET_READ = 'SET_READ'

export const CHANGE_REG_SHOW = 'CHANGE_REG_SHOW'

export const CHANGE_FORGET_SHOW = 'CHANGE_FORGET_SHOW'

export const CHANGE_ISVERTIFYSUCC = 'CHANGE_ISVERTIFYSUCC'

export const SCORE = 'SCORE'

export const SCORE_SHOW = 'SCORE_SHOW'

export const READ_NUM = 'READ_NUM'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js